import { render, staticRenderFns } from "./AppFormItems.vue?vue&type=template&id=0d9cecca"
import script from "../../../controllers/custom/application_form/app-form-items.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/application_form/app-form-items.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports